import { Menu } from './../../../util/menu';
import { JWT_RESPONSE_HEADER } from './../../../seguridad/seguridad/constantes';
import { UsuarioPublicService } from 'src/app/seguridad/seguridad/usuario.public.service';
import { AppComponent } from './../../../app.component';
import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MenuItem } from 'primeng/primeng';
import { ShellComponent } from '../shell.component';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { UsuarioActual } from '../../../util/usuarioactual';
import { SeguridadService } from '../../../seguridad/seguridad/seguridad.service';


@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="model" root="true" class="layout-menu"
            [reset]="reset" visible="true" parentActive="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

    @Input() reset: boolean;

    model: any[];

    constructor(public app: AppComponent,
        private service: SeguridadService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {

        const ss = sessionStorage.getItem('ua');
        let usuario: UsuarioActual;
        usuario = JSON.parse(ss);

        this.model = [
            { label: 'Cargando...', icon: 'fa fa-fw fa-spinner' }];

        this.service.obtenerMenu(usuario.usuarioLogin).then(
            menu => {
                this.model = [];
                this.model = [
                    {
                        label: 'Dashboard', icon: 'fa fa-home',routerLink: ['home']
                    },
                ];

                if (menu.items) {
                    let i:number=0;
                    menu.items.forEach(element => {
                        let grupo: any = { label: element.label, icon: element.icon, routerLink: ['/spring/'] };

                        if (element.items) {

                            grupo = { label: element.label, icon: element.icon, items: [] };

                            element.items.forEach(element2 => {

                                if (element2.routerLink) {

                                    element2.routerLink = element2.routerLink == null ? null : element2.routerLink.trim();

                                    grupo.items.push({
                                        label: element2.label, icon: element2.icon,
                                        command: event => this.app.lightMenu = true, routerLink: [element2.routerLink]
                                    });
                                }  else {
                                    grupo.items.push({
                                        label: element2.label, icon: element2.icon,
                                        command: event => this.app.lightMenu = true
                                    });

                                }

                                this.model.push(grupo.items[i]);
                                i++;
                            });
                        }
                   //this.model.push(grupo.items);
                    });
                }

            }
        );
    }

    changeTheme(theme: string, scheme: string) {
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';

        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        themeLink.href = 'assets/theme/theme-' + theme + '.css';

    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-submenu]',
    /* tslint:enable:component-selector */
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass" *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)"
                   class="ripplelink" *ngIf="!child.routerLink"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon"></i><span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="child.items"></i>
                </a>

                <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" class="ripplelink" *ngIf="child.routerLink"
                   [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon"></i><span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="child.items"></i>
                </a>
                <div class="submenu-arrow" *ngIf="child.items"></div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset" [parentActive]="isActive(i)"
                    [@children]="(app.isSlim()||app.isHorizontal())&&root ? isActive(i) ?
                    'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px',
                opacity: 0
            })),
            state('visibleAnimated', style({
                height: '*',
                opacity: 1
            })),
            state('visible', style({
                height: '*',
                'z-index': 100,
                opacity: 1
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*',
                opacity: 0
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    _parentActive: boolean;

    activeIndex: number;

    constructor(public app: ShellComponent) { }

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
          
            if(item.label==='Pedido'){
                sessionStorage.setItem('filtrosPedidos', 'LIMPIAR');
            }

            if(item.label==='Cotización'){
                sessionStorage.setItem('filtrosCotizacion', 'LIMPIAR');
            }
            
            item.command({ originalEvent: event, item: item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.app.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }
        
        
        
        // // hide menu
        if (!item.items) {
            if(item.label=="Dashboard"){
                // document.getElementById("j_principal").style.padding="80px 20px 20px";
                document.getElementById("j_cabezaDashboard").style.height="60px";
                //document.getElementById("j_usuario").style.display="flex";
                // document.getElementById("j_logo").style.display="none";
                
            }else{
                document.getElementById("j_cabezaDashboard").style.height="60px";
                // document.getElementById("j_principal").style.padding="80px 20px 20px";
                //document.getElementById("j_usuario").style.display="none";
                // document.getElementById("j_logo").style.display="none";
            }
            
        
       /*  document.getElementById("j_principal").style.paddingTop="0 !important";*/
         
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())
            && !this.app.isMobile() && !this.app.isTablet()) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}

